import { createDeleteEndpoint } from '@sonar-software/sonar-http';

export const deleteNotifications = createDeleteEndpoint('/api/v3/notifications');
